import {
  Control,
  FieldErrors,
  UseFormSetValue,
  useWatch,
} from 'react-hook-form'
import { View } from 'react-native'
import { StyleSheet } from 'react-native-unistyles'

import {
  AdvancedFilterField,
  AdvancedFilterFormValues,
} from '@/components/filtering/advanced/AdvancedFilterTypes'
import AdvancedFilterOperatorField from '@/components/filtering/advanced/fields/AdvancedFilterOperatorField'
import AdvancedFilterValueField from '@/components/filtering/advanced/fields/AdvancedFilterValueField'
import FormFieldSelect from '@/components/form/FormFieldSelect'
import UniIconButton from '@/components/unistyles/UniIconButton'

interface Props {
  control: Control<AdvancedFilterFormValues>
  errors: FieldErrors<AdvancedFilterFormValues>
  id: string
  index: number
  remove: (index: number) => void
  fields: AdvancedFilterField[]
  setValue: UseFormSetValue<AdvancedFilterFormValues>
}

const AdvancedFilterRow: React.FC<Props> = ({
  control,
  errors,
  index,
  remove,
  fields,
  setValue,
  id,
}) => {
  const fieldOptions = fields.map((f) => ({ label: f.title, value: f.field }))

  const selectedFieldName = useWatch({
    control,
    name: `filters.${index}.field`,
  })

  const selectedOperator = useWatch({
    control,
    name: `filters.${index}.operator`,
  })

  const selectedField = fields.find((f) => f.field === selectedFieldName)

  return (
    <View key={id} style={styles.row}>
      <View style={styles.rowColumn}>
        {/* Field Selector */}
        <FormFieldSelect
          control={control}
          data={fieldOptions}
          fieldName={`filters.${index}.field`}
          label="Select Field"
          required
          style={styles.dropdown}
        />

        {/* Operator Selector */}
        <AdvancedFilterOperatorField
          control={control}
          dropdownStyle={styles.dropdown}
          errors={errors}
          index={index}
          selectedField={selectedField}
          selectedOperator={selectedOperator}
          setValue={setValue}
          textViewStyle={styles.dropdown}
        />

        {/* Value Input */}
        <AdvancedFilterValueField
          control={control}
          dropdownStyle={styles.dropdown}
          errors={errors}
          index={index}
          selectedField={selectedField}
          selectedOperator={selectedOperator}
          setValue={setValue}
          textViewStyle={styles.dropdown}
        />
      </View>
      <UniIconButton
        icon="minus-circle"
        onPress={() => {
          remove(index)
        }}
        style={{
          alignSelf: 'center',
          justifyContent: 'center',
        }}
      />
    </View>
  )
}

const styles = StyleSheet.create((theme) => {
  return {
    dropdown: {
      flex: {
        xs: 1,
        sm: 0.3,
      },
    },

    row: {
      alignItems: {
        xs: 'stretch',
        sm: 'center',
      },
      flexDirection: 'row',
      gap: theme.tokens.spacing[3],
      marginBottom: theme.tokens.spacing[3],
    },
    rowColumn: {
      flex: 1,
      flexDirection: {
        xs: 'column',
        sm: 'row',
      },
      gap: theme.tokens.spacing[3],
    },
  }
})

export default AdvancedFilterRow
